import { useSnackbar } from 'notistack';

let enqueueSnackbarRef = null;

export function SnackbarUtilsConfigurator() {
  enqueueSnackbarRef = useSnackbar().enqueueSnackbar;
  return null;
}

export function showSnackbar(message, options = {}) {
  if (enqueueSnackbarRef) {
    enqueueSnackbarRef(message, options);
  }
}
